import {CustomText, PSmallText} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {ActivityIndicator} from 'react-native';
import {HBox} from '@buncha/components/core/view';
import React from 'react';
import {styles} from './styles';

interface LoadingItemCellFooterProps {
  title: string;
  subtext: string;
}

const LoadingItemCellFooter: React.FC<LoadingItemCellFooterProps> = props => {
  const {title, subtext} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  return (
    <HBox
      style={[
        styles.container,
        {
          borderColor: theme?.text.gray[300],
          backgroundColor: theme?.background.gray[200],
        },
      ]}>
      <HBox style={styles.subContainer}>
        <ActivityIndicator />
        <CustomText
          style={[
            styles.textAlign,
            styles.titleStyle,
            {
              fontFamily: muliFont[700].normal,
              color: theme?.text.gray[100],
            },
          ]}>
          {title}
        </CustomText>
      </HBox>
      <PSmallText
        style={[styles.textAlign, {fontFamily: muliFont[700].normal}]}>
        {subtext}
      </PSmallText>
    </HBox>
  );
};

export default React.memo(LoadingItemCellFooter);
